import Component from "./CourseIcon";
export default Component;
